import id from './id.js'
import initialState from './initial-state.js'
import selectorDefinitions from './selectors/index.js'

const announcementsReduxDefinition = {
  id,
  type: 'redux-module',
  initialState,
  eventReducers: {
    allAnnouncements: (state, payload) => ({ ...state, allAnnouncements: payload }),
    visibleAnnouncements: (state, payload) => ({ ...state, visibleAnnouncements: payload }),
  },
  selectorDefinitions,
}

export default announcementsReduxDefinition
